/**************************************************
 * Nombre:       IngresoTexto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Checkbox} from "@mui/material";
import {useEffect, useState} from "react";


const IngresoCheck = ({
                          props,
                          dato,
                          editable = true
                      }) => {
    const {register, errors, setValue, watch, getValues} = props
    const [activo, setActivo] = useState(true)


    const cambio = (e) => {
        setValue(dato, e)
    }

    useEffect(() => {
        let dat = getValues(dato)
        setActivo(dat)
    }, [watch(dato)]);
    return (
        <Checkbox defaultChecked={activo} onChange={(e) => cambio(e.target.checked)}/>
    )

}
export default IngresoCheck